<template>
  <v-bottom-sheet
    v-model="bottomSheet.show"
    inset
    width="65%"
  >
    <v-sheet
      class="d-flex flex-column align-center justify-center pa-8"
      height="250px"
      rounded
    >
      <v-icon size="40" color="warning">
        mdi-lock
      </v-icon>
      <div class="mt-5 mb-5">
        {{$t('subscriptions.no_subscription')}}
      </div>
      <v-btn class="mb-3" color="green darken-1" variant="text" @click="contactSales()">
        {{ $t("components.dialog.premium_feature.contact_sales") }}
      </v-btn>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'ContactSalesBottomSheet',
  components: {},
  computed: {
    bottomSheet() {
      return this.$store.getters['userInterface/getContactSales'];
    },
  },
  methods: {
    contactSales() {
      let url;
      switch (this.$i18n.locale) {
      case 'sv':
        url = 'https://myspeaker.se/kontakta-oss/';
        break;
      case 'fi':
        url = 'https://myspeaker.fi/ota-yhteytta-rhetorich/';
        break;
      case 'fr':
        url = 'https://myspeaker.fr/contactez-nous/';
        break;
      case 'de':
      case 'sp':
      default:
        url = 'https://myspeaker.com/contact-myspeaker-rhetorich/';
        break;
      }

      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
</style>
